import { render, staticRenderFns } from "./DictionaryFormOfClasses.vue?vue&type=template&id=5d1d4b61&scoped=true&"
import script from "./DictionaryFormOfClasses.vue?vue&type=script&lang=js&"
export * from "./DictionaryFormOfClasses.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryFormOfClasses.vue?vue&type=style&index=0&id=5d1d4b61&scoped=true&lang=scss&"
import style1 from "./DictionaryFormOfClasses.vue?vue&type=style&index=1&id=5d1d4b61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d4b61",
  null
  
)

export default component.exports